import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as PlayIcon } from "../../assets/Icons/play.svg";
import { ReactComponent as HeartIcon } from "../../assets/Icons/heart.svg";
import { ReactComponent as HeartFillIcon } from "../../assets/Icons/heartFill.svg";
import { ReactComponent as PlayingIcon } from "../../assets/Icons/playingIcon.svg";
import Videos from "../Shorts/Player";
// import Comment from "../../Screens/VideoPlayer/Components/Comment";
import Verticalshow_Comments from "./Components/Verticalshow_Comments";
import InsertCommentIcon from '@mui/icons-material/InsertComment';
import ShareIcon from '@mui/icons-material/Share';
import { toast, ToastContainer } from 'react-toastify';
import Loading from "../../Components/Loading/Loading";
import LockIcon from "../../assets/Images/lock.png";
import Translate from "../../Components/MultiLanguage/Translate";
// import initializeFirebase from '../../firebaseConfig';
import { ref, onValue, off } from 'firebase/database';
import { imageUrlCheck, onVideoPlayFunction } from "../../utils/utils";
import * as service from "./service";
import { fetchComments } from "./service";

let debounce = true;
var videoStarted = false;
let seconds = 60;
let prevTime;
let videoPlaying = false;

const VerticalShowPlayer = () => {
    const projectInfo = useSelector((state) => state?.projectInfo?.value);
    const sessionId = useSelector((state) => state?.sessionId?.value);
    const accessToken = useSelector((state) => state?.accessToken?.value);
    const user = useSelector((state) => state?.user?.value);

    const [loading, setLoading] = useState(true);
    const [showData, setShowData] = useState(null);
    const [episodes, setEpisodes] = useState([]);
    const [currentEpisodeIndex, setCurrentEpisodeIndex] = useState(0);
    const [currentEpisode, setCurrentEpisode] = useState(null);
    const [likedEpisodes, setLikedEpisodes] = useState(new Set());
    const [isCommentModalOpen, setCommentModalOpen] = useState(false);
    const [shouldCloseCommentModal, setShouldCloseCommentModal] = useState(false);
    const [commentCount, setCommentCount] = useState(0);
    const [currentEpisodeRange, setCurrentEpisodeRange] = useState({ start: 0, end: 49 });
    const [episodeRanges, setEpisodeRanges] = useState([]);
    const [nextShowId, setNextShowId] = useState(null);
    const [totalComments, setTotalComments] = useState(0);

    const location = useLocation();
    const navigate = useNavigate();
    const { showIdentifier: paramShowId, episodeIdentifier: urlEpisodeId } = useParams();
    const playerRef = useRef(null);

    const episodeIdFromUrl = urlEpisodeId;
    const episodeId = episodeIdFromUrl;

    const appInfo = {
        projectDetails: projectInfo,
        accessToken: accessToken,
        sessionId,
    };
    let sortType = "latest"
    useEffect(() => {
        window.scroll(0, 0);
        const showIdentifier = paramShowId || location?.state?.showId || location?.state?.showVanity;
        if (showIdentifier) {
            fetchVerticalShowData(showIdentifier);
        } else {
            navigate(-1);
        }
    }, [paramShowId]);

    useEffect(() => {
        if (episodes?.length > 0 && currentEpisodeIndex >= 0) {
            setCurrentEpisode(episodes[currentEpisodeIndex]);
            
            const ep = episodes[currentEpisodeIndex];
            const episodeIdentifier = ep?.vanity_url || ep?.video_id;
            const showIdentifier = showData?.vanity_url || paramShowId;
            if (episodeIdentifier) {
                const newUrl = `/vertical-show/${showIdentifier}/${episodeIdentifier}`;
                if (location.pathname !== newUrl) {
                    navigate(newUrl, { replace: true, state: location.state });
                }
            }
        }
    }, [episodes, currentEpisodeIndex, paramShowId, navigate, location]);

    // useEffect(() => {
    //     let dbRef;
    //     const firebaseDB = initializeFirebase(projectInfo);
    //     if (currentEpisode) {
    //         setCommentCount(currentEpisode.comment_count || 0);
    //         setShouldCloseCommentModal(false);

    //         dbRef = ref(firebaseDB, `comments/${currentEpisode.video_id}`);
    //         onValue(dbRef, (snapshot) => {
    //             if (snapshot.exists()) {
    //                 const val = snapshot.val() || {};
    //                 const count = Array.isArray(val) ? val.filter(Boolean).length : Object.keys(val).length;
    //                 setCommentCount(count);
    //             } else {
    //                 setCommentCount(0);
    //             }
    //         });
    //     }

    //     return () => {
    //         if (dbRef) off(dbRef);
    //     };
    // }, [currentEpisode]);
 

    useEffect(() => {
        if (episodes?.length > 0) {
            const ranges = [];
            for (let i = 0; i < episodes.length; i += 50) {
                const end = Math.min(i + 49, episodes.length - 1);
                ranges.push({ start: i, end: end });
            }
            setEpisodeRanges(ranges);

            const currentRange = ranges.find(range =>
                currentEpisodeIndex >= range.start && currentEpisodeIndex <= range.end
            );
            if (currentRange) {
                setCurrentEpisodeRange(currentRange);
            }
        }
    }, [episodes, currentEpisodeIndex]);

      useEffect(() => {
        if (currentEpisode?.video_id) {
          _fetchComments(1, sortType, false, currentEpisode.video_id, appInfo).catch(err => {
            console.error(err)
          })
        }
      }, [currentEpisode?.video_id, appInfo]);
      
        useEffect(() => {
            setCommentCount(currentEpisode?.comment_count || 0);
        }, [currentEpisode?.video_id, currentEpisode?.comment_count]);

    const fetchVerticalShowData = async (showIdentifier) => {
        try {
            setLoading(true);
            const response = await service.getVerticalShowsList(appInfo, showIdentifier || paramShowId);
            if (response?.status === 200) {
                const responseData = response.data;
                setShowData(responseData.show);
                setEpisodes(responseData.data);
                setNextShowId(responseData.next_show_id);

                const liked = new Set();
                responseData?.data?.forEach(episode => {
                    if (episode.liked) {
                        liked.add(episode.video_id);
                    }
                });
                setLikedEpisodes(liked);

                let targetIndex = 0;
                
                    if (episodeId) {
                        const episodeIndex = responseData.data.findIndex(ep => {
                            return String(ep.video_id) === String(episodeId) || String(ep.vanity_url) === String(episodeId) || String(ep.share_url) === String(episodeId);
                        });
                        if (episodeIndex !== -1) {
                            targetIndex = episodeIndex;
                        }
                    } else if (responseData.resume_video_id) {
                        const resumeIndex = responseData.data.findIndex(ep => String(ep.vanity_url) === String(responseData.resume_video_id) || String(ep.video_id) === String(responseData.resume_video_id));
                        if (resumeIndex !== -1) {
                            targetIndex = resumeIndex;
                        }
                    } else {
                        targetIndex = 0;
                    }
                setCurrentEpisodeIndex(targetIndex);
            } else if (response?.status === 401) {
                navigate(projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === "true" ? "/checkout" : "/login", {
                    state: {
                        path: location?.pathname,
                        prevPath: location?.state?.prevPath,
                        activeLogin: true,
                        from: "VerticalShowPlayer"
                    }
                });
                return;
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching vertical show data:", error);
            setLoading(false);
        }
    };

    const handleVideoStart = () => {
        if (!videoStarted && currentEpisode) {
            videoStarted = true;
            videoPlaying = true;
            if (debounce) {
                setTimeout(() => {
                    onVideoPlayFunction(
                        appInfo,
                        currentEpisode,
                        'POP12',
                        0
                    );
                }, 5000);
                debounce = false;
            }
        }
    };

    const handleVideoEnd = () => {
        videoPlaying = false;
        videoStarted = false;
        debounce = true;
        playNextEpisode();
    };

    const playNextEpisode = () => {
        if (currentEpisodeIndex < episodes.length - 1) {
            setCurrentEpisodeIndex(currentEpisodeIndex + 1);
            videoStarted = false;
            debounce = true;
        } else {
            if (nextShowId) {
                setShowData([]);
                setEpisodes([]);
                navigate(`/vertical-show/${nextShowId}`);
            } else {
                if (playerRef.current) {
                    playerRef.current.pause();
                }
            }
        }
    };

    const playPreviousEpisode = () => {
        if (currentEpisodeIndex > 0) {
            setCurrentEpisodeIndex(currentEpisodeIndex - 1);
            videoStarted = false;
            debounce = true;
        }
    };

    const selectEpisodeRange = (range) => {
        setCurrentEpisodeRange(range);
    };

    const selectEpisode = (index) => {
        if (index !== currentEpisodeIndex) {
            setCurrentEpisodeIndex(index);
            videoStarted = false;
            debounce = true;
        }
    };

    const formatDuration = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
    };

    const getCurrentVisibleEpisodes = () => {
        return episodes?.slice(currentEpisodeRange.start, currentEpisodeRange.end + 1) || [];
    };

    const toggleLike = async (episode) => {
        if (!user) {
            navigate(projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == "true" ? "/checkout" : "/login", {
                state: { path: location?.pathname, showId: paramShowId, prevPath: location?.state?.prevPath, activeLogin: true, from: "VerticalShowPlayer" },
            });
            return;
        }

        const newLikedStatus = !likedEpisodes.has(episode.video_id);

        try {
            const response = await service.likeHandler(episode.video_id, newLikedStatus, appInfo);

            if (response?.success) {
                const newLikedEpisodes = new Set(likedEpisodes);

                if (newLikedStatus) {
                    newLikedEpisodes.add(episode.video_id);
                } else {
                    newLikedEpisodes.delete(episode.video_id);
                }

                setLikedEpisodes(newLikedEpisodes);

                const updatedEpisodes = episodes.map(ep => {
                    if (ep.video_id === episode.video_id) {
                        return {
                            ...ep,
                            liked: newLikedStatus,
                            like_count: newLikedStatus ? ep.like_count + 1 : Math.max(0, ep.like_count - 1)
                        };
                    }
                    return ep;
                });

                setEpisodes(updatedEpisodes);
            }
        } catch (error) {
            console.error("Error toggling like for episode:", episode.video_id, error);
        }
    };

    const handleShareClick = async () => {
        const shareUrl = currentEpisode?.share_url || `${window.location.origin}${location?.pathname}`;
        try {
            await navigator.clipboard.writeText(shareUrl);
            toast.success(<Translate textKey={'copied'} />);
        } catch (error) {
            console.error('Failed to copy text:', error);
            toast.error('Failed to copy');
        }
    };

      const _fetchComments = async (page = 1, sort = sortType === "New" ? "Latest" : "Popular", prepend = false, Id, appInfo ) => {
        try {
          const params = {page, sort, video_id : Id, timestamp: new Date().getTime()};
          const response = await fetchComments(appInfo, params);
          if (response.data.success) {
            const page = response.data.page;
            setTotalComments(response.data.total);
           
          }
        } catch (error) {
          console.error("Error fetching comments:", error);
        }
    };

    if (loading) {
        return <Loading />;
    }

    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 1024;
    if (isMobile) {
        return (
            <>
                {isCommentModalOpen && currentEpisode && (
                    <div className="vertical-comments">
                        <div className="comment-modal">
                            <Verticalshow_Comments
                                videoId={currentEpisode.video_id}
                                projectInfo={projectInfo}
                                setCommentModalOpen={(val) => { setCommentModalOpen(val); if (!val) setShouldCloseCommentModal(true); }}
                                setCommentCount={setCommentCount}
                            />
                        </div>
                    </div>
                )}
                <div className="verticalShowPlayer">
                    <div className="playerContainer">
                        <div className="leftPanel">
                            <div className="videoPlayer">
                                {currentEpisode && (
                                    currentEpisode.subscribed === false ? (
                                        <div className="video-container lockedBackground">
                                            <img
                                                className="lockedBackgroundImage"
                                                src={currentEpisode.thumbnail || showData?.logo || ""}
                                                alt={showData?.show_name || currentEpisode.title}
                                            />
                                            <div className="lockedOverlay">
                                                <img
                                                    className="lockedThumb"
                                                    src={currentEpisode.thumbnail || showData?.logo}
                                                    alt={currentEpisode.title}
                                                />
                                                <div className="lockedText">
                                                    <p><Translate textKey="no_subscription_to_play" /></p>
                                                    <button
                                                        className="lockedButton"
                                                        onClick={() => {
                                                            if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === "true") {
                                                                navigate("/checkout", { state: { videoId: currentEpisode.video_id, prevPath: location?.pathname, showId: paramShowId, from: "VerticalShowPlayer" } });
                                                            } else {
                                                                navigate("/subscription", { state: { videoId: currentEpisode.video_id, prevPath: location?.pathname, showId: paramShowId, from: "VerticalShowPlayer" } });
                                                            }
                                                        }}
                                                    >
                                                        <Translate textKey="subscription_plans" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <Videos
                                                key={currentEpisode.video_id}
                                                id={`episode-${currentEpisode.video_id}`}
                                                originalId={currentEpisode.video_id}
                                                src={currentEpisode?.url}
                                                subtitles={currentEpisode.subtitles || []}
                                                like={currentEpisode.like_count}
                                                comment={currentEpisode.comment_count || 0}
                                                shareUrl=""
                                                title=""
                                                desc=""
                                                projectInfo={projectInfo}
                                                video_time={currentEpisode.video_time}
                                                isVisible={true}
                                                isInitial={true}
                                                appInfo={appInfo}
                                                vanityUrl={currentEpisode.vanity_url}
                                                liked_flag={null}
                                                poster={currentEpisode.thumbnail}
                                                handleScroll={() => { }}
                                                ensureNextFetch={() => { }}
                                                shouldCloseCommentModal={shouldCloseCommentModal}
                                                setShouldCloseCommentModal={setShouldCloseCommentModal}
                                                onVideoEnd={handleVideoEnd}
                                                onVideoStart={handleVideoStart}
                                                showControls={true}
                                                hideAllOverlays={true}
                                            />
                                        </>
                                    )
                                )}
                            </div>
                        </div>
                        <div className="rightPanel">
                            <div className="showInfo">
                                {showData && currentEpisode && (
                                    <div className="showTitleRow">
                                        <span
                                            className="showTitle"
                                            onClick={() => navigate(`/show-details/${paramShowId}`)}
                                        >
                                            {showData.show_name}
                                        </span>
                                        <span className="slashSeparator">/</span>
                                        <span className="episodeTitleText">{currentEpisode.episode_text}</span>
                                    </div>
                                )}
                            </div>
                            <div className="episodesList">
                                <div className="episodeRanges">
                                    {episodeRanges.map((range, index) => {
                                        const isActive = range.start === currentEpisodeRange.start;
                                        const label = range.start === range.end ?
                                            `${range.start + 1}` :
                                            `${range.start + 1}-${range.end + 1}`;
                                        return (
                                            <button
                                                key={index}
                                                className={`rangeButton ${isActive ? 'active' : ''}`}
                                                onClick={() => selectEpisodeRange(range)}
                                            >
                                                {label}
                                            </button>
                                        );
                                    })}
                                </div>
                                <div className="episodesContainer">
                                    <div className="episodesGrid">
                                        {getCurrentVisibleEpisodes().map((episode, index) => {
                                            const actualIndex = currentEpisodeRange.start + index;
                                            const subscribedLock = episode.subscribed === false;
                                            return (
                                                <div
                                                    key={episode.video_id}
                                                    className={`episodeItem ${actualIndex === currentEpisodeIndex ? 'active' : ''}`}
                                                    onClick={() => selectEpisode(actualIndex)}
                                                >
                                                    {subscribedLock && (
                                                        <div className="episodeLock">
                                                            <img src={LockIcon} alt="locked" />
                                                        </div>
                                                    )}
                                                    {actualIndex === currentEpisodeIndex ? <PlayingIcon /> : episode?.title}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                                {currentEpisode && (
                                    <div className="currentEpisodeInfo mobile">
                                        <div className="metadata">
                                            {currentEpisode.description ? (
                                                <p className="episodeDescription">{currentEpisode.description}</p>
                                            ) : showData?.synopsis && (
                                                <p className="episodeDescription">
                                                    {showData.synopsis.length > 150
                                                        ? `${showData.synopsis.substring(0, 150)}...`
                                                        : showData.synopsis
                                                    }
                                                    {showData.synopsis.length > 150 && (
                                                        <button
                                                            className="moreBtn"
                                                            onClick={() => navigate(`/show-details/${paramShowId}`)}
                                                        >
                                                            <Translate textKey={'more'} />
                                                        </button>
                                                    )}
                                                </p>
                                            )}
                                        </div>
                                        <div className="episodeButtonsRow">
                                            <button
                                                className={`likeBtn ${likedEpisodes.has(currentEpisode.video_id) ? 'liked' : ''}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    toggleLike(currentEpisode);
                                                }}
                                            >
                                                {likedEpisodes.has(currentEpisode.video_id) ? <HeartFillIcon /> : <HeartIcon />}
                                                <span>{currentEpisode.like_count}</span>
                                            </button>
                                            {projectInfo?.projectConfig?.config?.COMMENTS_REQUIRED === "true" &&
                                                <button
                                                    className="actionBtn commentBtn"
                                                    onClick={() => {
                                                        if (!user) {
                                                            navigate(projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == "true" ? "/checkout" : "/login", {
                                                                state: { path: location?.pathname, showId: paramShowId, prevPath: location?.state?.prevPath, activeLogin: true, from: "VerticalShowPlayer" },
                                                            });
                                                            return;
                                                        }
                                                        setCommentModalOpen(true);
                                                        setShouldCloseCommentModal(false);
                                                    }}
                                                >
                                                    <InsertCommentIcon />
                                                    <span>{totalComments}</span>
                                                </button>
                                            }
                                            <button className="actionBtn shareBtn" onClick={handleShareClick}>
                                                <ShareIcon />
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            {/* <ToastContainer /> */}
            {isCommentModalOpen && currentEpisode && (
                <div className="vertical-comments">
                    <div className="comment-modal">
                        <Verticalshow_Comments
                            videoId={currentEpisode.video_id}
                            projectInfo={projectInfo}
                            setCommentModalOpen={(val) => { setCommentModalOpen(val); if (!val) setShouldCloseCommentModal(true); }}
                            setCommentCount={setCommentCount}
                        />
                    </div>
                </div>
            )}
            <div className="verticalShowPlayer">
                <div className="playerContainer">
                    <div className="leftPanel">
                        <div className="videoPlayer">
                            {currentEpisode && (
                                currentEpisode.subscribed === false ? (
                                    <div className="video-container lockedBackground">
                                        <img
                                            className="lockedBackgroundImage"
                                            src={currentEpisode.thumbnail || showData?.logo || ""}
                                            alt={showData?.show_name || currentEpisode.title}
                                        />

                                        <div className="lockedOverlay">
                                            <img
                                                className="lockedThumb"
                                                src={currentEpisode.thumbnail || showData?.logo}
                                                alt={currentEpisode.title}
                                            />
                                            <div className="lockedText">
                                                <p><Translate textKey="no_subscription_to_play" /></p>
                                                <button
                                                    className="lockedButton"
                                                    onClick={() => {
                                                        if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === "true") {
                                                            navigate("/checkout", { state: { videoId: currentEpisode.video_id, prevPath: location?.pathname, showId: paramShowId, from: "VerticalShowPlayer" } });
                                                        } else {
                                                            navigate("/subscription", { state: { videoId: currentEpisode.video_id, prevPath: location?.pathname, showId: paramShowId, from: "VerticalShowPlayer" } });
                                                        }
                                                    }}
                                                >
                                                    <Translate textKey="subscription_plans" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <Videos
                                            key={currentEpisode.video_id}
                                            id={`episode-${currentEpisode.video_id}`}
                                            originalId={currentEpisode.video_id}
                                            src={currentEpisode?.url}
                                            subtitles={currentEpisode.subtitles || []}
                                            like={currentEpisode.like_count}
                                            comment={currentEpisode.comment_count || 0}
                                            shareUrl=""
                                            title=""
                                            desc=""
                                            projectInfo={projectInfo}
                                            video_time={currentEpisode.video_time}
                                            isVisible={true}
                                            isInitial={true}
                                            appInfo={appInfo}
                                            vanityUrl={currentEpisode.vanity_url}
                                            liked_flag={null}
                                            poster={currentEpisode.thumbnail}
                                            handleScroll={() => { }}
                                            ensureNextFetch={() => { }}
                                            shouldCloseCommentModal={shouldCloseCommentModal}
                                            setShouldCloseCommentModal={setShouldCloseCommentModal}
                                            onVideoEnd={handleVideoEnd}
                                            onVideoStart={handleVideoStart}
                                            showControls={true}
                                            hideAllOverlays={true}
                                        />

                                    </>
                                )
                            )}
                        </div>
                    </div>

                    <div className="rightPanel">
                        <div className="showInfo">
                            {showData && (
                                <h1
                                    className="showTitle"
                                    onClick={() => navigate(`/show-details/${paramShowId}`)}
                                >
                                    {showData.show_name}
                                </h1>
                            )}
                        </div>

                        {currentEpisode && (
                            <div className="currentEpisodeInfo">
                                <div className="metadata">
                                    <h2 className="episodeTitle">
                                        {/* {currentEpisode?.title === "Trailer" ? currentEpisode?.title : <><Translate textKey="episode" /> {currentEpisode.episode_number}</>} */}
                                        {currentEpisode?.episode_text}
                                    </h2>
                                    {currentEpisode.description ? (
                                        <p className="episodeDescription">{currentEpisode.description}</p>
                                    ) : showData?.synopsis && (
                                        <p className="episodeDescription">
                                            {showData.synopsis.length > 150 
                                                ? `${showData.synopsis.substring(0, 150)}...` 
                                                : showData.synopsis
                                            }
                                            {showData.synopsis.length > 150 && (
                                                <button 
                                                    className="moreBtn"
                                                    onClick={() => navigate(`/show-details/${paramShowId}`)}
                                                >
                                                    <Translate textKey={'more'} />
                                                </button>
                                            )}
                                        </p>
                                    )}
                                </div>
                                <div className="episodeButtonsRow">
                                    <button
                                        className={`likeBtn ${likedEpisodes.has(currentEpisode.video_id) ? 'liked' : ''}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            toggleLike(currentEpisode);
                                        }}
                                    >
                                        {likedEpisodes.has(currentEpisode.video_id) ? <HeartFillIcon /> : <HeartIcon />}
                                        <span>{currentEpisode.like_count}</span>
                                    </button>

                                    {projectInfo?.projectConfig?.config?.COMMENTS_REQUIRED === "true" && 
                                        <button
                                            className="actionBtn commentBtn"
                                            onClick={() => {
                                                if (!user) {
                                                    navigate(projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == "true" ? "/checkout" : "/login", {
                                                        state: { path: location?.pathname, showId: paramShowId, prevPath: location?.state?.prevPath, activeLogin: true, from: "VerticalShowPlayer" },
                                                    });
                                                    return;
                                                }
                                                setCommentModalOpen(true);
                                                setShouldCloseCommentModal(false);
                                            }}
                                        >
                                            <InsertCommentIcon />
                                            <span>{totalComments}</span>
                                        </button>
                                    }

                                    <button className="actionBtn shareBtn" onClick={handleShareClick}>
                                        <ShareIcon />
                                    </button>
                                </div>
                            </div>
                        )}

                        <div className="episodesList">
                            <div className="episodeRanges">
                                {episodeRanges.map((range, index) => {
                                    const isActive = range.start === currentEpisodeRange.start;
                                    const label = range.start === range.end ?
                                        `${range.start + 1}` :
                                        `${range.start + 1}-${range.end + 1}`;
                                    return (
                                        <button
                                            key={index}
                                            className={`rangeButton ${isActive ? 'active' : ''}`}
                                            onClick={() => selectEpisodeRange(range)}
                                        >
                                            {label}
                                        </button>
                                    );
                                })}
                            </div>
                            <div className="episodesContainer">
                                <div className="episodesGrid">
                                    {getCurrentVisibleEpisodes().map((episode, index) => {
                                        const actualIndex = currentEpisodeRange.start + index;
                                        const subscribedLock = episode.subscribed === false;
                                        return (
                                            <div
                                                key={episode.video_id}
                                                className={`episodeItem ${actualIndex === currentEpisodeIndex ? 'active' : ''}`}
                                                onClick={() => selectEpisode(actualIndex)}
                                            >
                                                {subscribedLock && (
                                                    <div className="episodeLock">
                                                        <img src={LockIcon} alt="locked" />
                                                    </div>
                                                )}
                                                {actualIndex === currentEpisodeIndex ? <PlayingIcon /> : episode?.title}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VerticalShowPlayer;
